import { render, staticRenderFns } from "./SimulationImportMass.vue?vue&type=template&id=2e2482e0&"
import script from "./SimulationImportMass.vue?vue&type=script&lang=js&"
export * from "./SimulationImportMass.vue?vue&type=script&lang=js&"
import style0 from "./SimulationImportMass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports